<template>
<div>
    <Navbar />
    <Breadcrumbs></Breadcrumbs>
    <EmployeesCards/>
    <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import EmployeesCards from '@/components/employees/EmployeesCards.vue'
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Navbar,
    EmployeesCards,
    Footer
  }
}
</script>

<style scoped>

</style>